/* import __COLOCATED_TEMPLATE__ from './selector-opener.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();